angular.module('salesPath2')
  .config(['$stateProvider',
    function myAppConfig($stateProvider) {
      $stateProvider
        .state('shortPath', {
          url: '/shortPath',
          views: {
            main: {
              templateUrl: 'salesPath2Template/pages/shortPath/shortPath.tpl.html',
              controller: 'shortPathCtrl'
            }
          }
        });
    }
  ]);